export const searchedElementDisplay = (item, search) => {
    return (
      !item?.name?.toLowerCase().includes(search?.toLowerCase()) &&
      search?.length > 0
    );
  };
  